import React from "react"
import { useNavigate } from "react-router-dom"
import { ButtonProps } from "./ButtonProps"

const SecondaryButton: React.FC<ButtonProps> = ({
  label,
  icon,
  to,
  onClick,
  className = "",
  type = "button",
}) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (to) {
      return navigate(to)
    } else if (onClick) {
      return onClick()
    } else {
      return false
    }
  }

  return (
    <button type={type} onClick={handleClick} className={`secondaryButton com-button ${className}`}>
      {icon && <span className='icon me-1'>{icon}</span>}
      {label}
    </button>
  )
}

export default SecondaryButton
